export default "__VITE_ASSET__1ba234ce__"